module.exports = __webpack_public_path__ + "img/20.b66e50d5.jpg";